import styled from "styled-components";

export const BannerSection = styled.section`
  position: sticky;
  height: 100%;
  min-height: 100px;
  @media screen and (max-height: 500px) {
    display: none;
  }

  .loading__container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .corner__text {
    position: absolute;
    background-color: #7515ed;
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 5px 10px;
    width: fit-content;
    border-radius: 30px;
    grid-area: header;
    color: white;
    bottom: 10px;
    right: 10px;
    font-size: 13px;
    box-shadow: 4px 4px 4px 0px #00000040;
    @media screen and (max-width: 1100px) {
      font-size: 10px;
      bottom: 0;
      right: 0;
      border-radius: 10px;
      border-bottom-left-radius: 0;
      border-top-right-radius: 0;
      box-shadow: none;
    }
    @media screen and (max-width: 850px) {
      padding: 5px 5px;
    }
    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .bannerLink {
    height: 100%;
    cursor: pointer;
  }
  .banner {
    position: relative;
    height: 100%;
    z-index: -10;
    border-radius: 10px;
    overflow: hidden;
    font-family: "Open Sans", sans-serif;
    display: grid;
    grid-template-columns: 70% 1fr;
  }

  .svg {
    position: absolute;
    height: 100%;
    max-width: 100%;
    width: auto;
    z-index: -1;
    right: -10px;
  }

  .textArea {
    box-sizing: border-box;
    /* padding: 14px; */
    /* position: absolute; */
    left: 0;
    height: 100%;
    width: auto;
    display: grid;
    grid-template-columns: 9fr 1fr;
    position: relative;
  }

  .textContainer {
    background-color: white;
    padding: 20px 0px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    justify-content: center;
    @media screen and (max-width: 1100px) {
      padding: 10px 0 10px 10px;
      gap: 5px;
    }
  }

  .textContainer > p {
    text-align: left;
    color: black;
    text-decoration: none;
    font-size: clamp(9px, calc(1px + 0.8vw), 15px);
    background-color: white;
    max-width: 90%;
  }

  .textContainer > h3 {
    font-weight: 700;
    text-align: left;
    color: black;
    text-decoration: none;
    font-size: clamp(9px, calc(1px + 0.8vw), 15px);
    background-color: white;
    max-width: 90%;
  }

  .banner__image {
    object-fit: cover;
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 60%;
    position: absolute;
    top: 0;
    right: -15%;
    z-index: -2;
  }
`;
